import { apiClient } from '../client/apiClient';

export const getUploadSecureInfo = async (queryParams: Record<string, string>) => {
  const { data, response } = await apiClient.GET('/files/get-upload-secure-info', {
    params: { query: queryParams as any }
  });
  if (response.status === 404) {
    return response; // GetSecureFileUploadInfo endpoint is optional
  }
  return data as any; //FIXME provide return type;
};
